import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

// Using the same Firebase project as the Chrome extension for data consistency
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBVPIBIjmAuGaJeoBrf3YNIgyjBZvloktI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "gd-text-expander.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "gd-text-expander",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "gd-text-expander.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "288913623256",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:288913623256:web:gd-shortcuts-web"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// Restrict to your domain
googleProvider.setCustomParameters({
  hd: 'gangerdermatology.com'
});

// Connect to emulators if running locally
if (process.env.REACT_APP_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
}

export const signInWithGoogle = () => signInWithPopup(auth, googleProvider);